// target sales code............................

import React, { useEffect, useState, useRef } from "react";
import {
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Typography,
  TableRow,
  Paper,
  Checkbox,
  Tooltip,
  Box,
  DialogContentText,
  TableFooter,
  Modal
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { EyeOutlined } from "@ant-design/icons";
// import { Add as AddIcon, Delete as DeleteIcon } from '@material-ui/icons';
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { useSelector } from "react-redux";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { border, height, width } from "@mui/system";
import HttpService from "../services/httpService";
import { CSVLink } from "react-csv";
import { setLoading, setSnackInfo } from "../redux/actions/appAction";
import { connect } from "react-redux";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import { ROLENAME } from '../utils';
import * as XLSX from "xlsx";
import moment from 'moment';


import axios from "axios";
import { Header } from "antd/es/layout/layout";

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: "absolute",
    top: "16px",
    right: "16px",
    zIndex: 2,
  },
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%",
    position: "relative",
  },

  form: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    maxWidth: 400,
    margin: "0 auto",
  },
  button: {
    marginTop: theme.spacing(2),
  },
  table: {
    minWidth: 650,
    border: "1px solid #ddd", // Add border to the table
  },
  tableCell: {
    textAlign: "center",
    border: "1px solid #ddd", // Add border to table cells
    whiteSpace: "normal", // Allow wrapping of content
    wordWrap: "break-word", // Break words that exceed the width
    maxWidth: "150px", // Example maximum width
    padding: "8px", // Adjust padding as needed
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  input: {
    display: "none",
  },
  downloadButton: {
    backgroundColor: '#355025',   // Dark Blue
    color: '#FFF2EB',             // White text
    '&:hover': {
      backgroundColor: '#4A6641', // Derived lighter Dark Blue
    },
  },
}));
function Incentives(props) {
  const classes = useStyles();
  const { userDetails } = useSelector((state) => state.user);
  const [incentivesData, setIncentivesData] = useState({});
  const [adminIncentives, setAdminIncentivesData] = useState({});
  const [yearFilterValue, setYearFilterValue] = useState(
    new Date().getFullYear()
  );
  const [radioValue, setRadioValue] = useState("NA");
  const [monthFilter, setMonthFilter] = useState("all");
  const [hierarchyCsv, setHierarchyCsv] = useState([]);
  const [initiatePipInfo, setInitiatePipInfo] = useState({});
  const [allExeperienceCenter, setAllExperienceCenter] = useState({});
  const [selectExperienceCenter, setSelectExperienceCenter] = useState("all");
  const [hierarchyCsvData, setHierarchyCsvData] = useState([]);
  const [adminCsvData, setAdminCsvData] = useState([]);
  const [leadData, setLeadData] = useState([]);
  const [hierarchyHeader, setHierarchyHeader] = useState([])
  const [adminToggle, setAdminToggle] = useState(false)
  const [userType,setUserType] = useState(false)
  const [loading,setLoading] = useState(false)
  const [roleHistoryModal, setRoleHistoryModal] = useState(false);
  const [selectedRoleHistory, setSelectedRoleHistory] = useState([]);
  const [selectedUserName, setSelectedUserName] = useState("");

  // rupees format----
  function formatRupees(amount) {
    const amountInLacs = amount / 100000;
    return new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3,
    }).format(amountInLacs);
  }

  function flattenedDataFunHandle(data) {
    return data?.map((item) => {
      let formattedItem = {
        name: item.name || "N/A",
        role: item?.roles?.join(", ") || "N/A",
        ec: item?.experienceCenters?.join(", ") || "N/A",
      };
  
      // Dynamically assign month-based keys
      item?.data?.forEach((entry) => {
        if (entry?.month) {
          formattedItem[entry.month] = entry.incentive || 0;
        }
      });
  
      return formattedItem;
    }) || [];
  }

  // finding month name via numbers
  function findMonthName(monthNumber) {
    const result =
      monthNumber === 1
        ? "Jan"
        : monthNumber === 2
        ? "Feb"
        : monthNumber === 3
        ? "March"
        : monthNumber === 4
        ? "Apr"
        : monthNumber === 5
        ? "May"
        : monthNumber === 6
        ? "June"
        : monthNumber === 7
        ? "July"
        : monthNumber === 8
        ? "Aug"
        : monthNumber === 9
        ? "Sept"
        : monthNumber === 10
        ? "Oct"
        : monthNumber === 11
        ? "Nov"
        : monthNumber === 12
        ? "Dec"
        : "Invalid month";
    // - {ele.year}

    return result;
  }

  // Get All Experience Center

  async function getExperienceCenterHandleFun() {
    try {
      props.setLoading(true);
      const fetchData = await HttpService.getAllExperienceCenter();
      setAllExperienceCenter(fetchData.data);
      props.setLoading(false);
    } catch (error) {
      props.setLoading(false);
    }
  }
  //   get Incentives api call
  async function getIncentivesHandle(year, month, userId) {
    try {
      // props.setLoading(true);
      setLoading(true)
      const fetchData = await HttpService?.getIncentivesApi(
        year,
        month,
        userId
      );
      setIncentivesData(fetchData?.data);
      // props.setLoading(false);
      setLoading(false)
    } catch (error) {
      props.setLoading(false);
    }
    finally{
      setLoading(false)
    }
  }

  // Get All Experience Center

  async function getExperienceCenterHandleFun() {
    try {
      props.setLoading(true);
      const fetchData = await HttpService.getAllExperienceCenter();
      setAllExperienceCenter(fetchData.data);
      props.setLoading(false);
    } catch (error) {
      props.setLoading(false);
    }
  }

  //   get Incentives Admin api call
  async function getAdminIncentivesHandle(year, month, ecId,isDeactivatedToggle) {
    try {
      // props.setLoading(true);
      setLoading(true)
      const fetchData = await HttpService.getAdminIncentivesApi(
        year,
        month,
        ecId,
        isDeactivatedToggle
      );
      setAdminIncentivesData(fetchData.data);
      // props.setLoading(false);
      setLoading(false)
    } catch (error) {
      props.setLoading(false);
    }finally{
      setLoading(false)
    }
  }


  useEffect(() => {
    if (userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager"))) {
      getAdminIncentivesHandle(
        yearFilterValue,
        monthFilter,
        selectExperienceCenter,
        userType
      );
      getExperienceCenterHandleFun();
    } else {
      getIncentivesHandle(yearFilterValue, monthFilter, userDetails?._id);
    }
  }, [yearFilterValue, monthFilter, selectExperienceCenter, userDetails,userType]);

  //CSV useEffect---------


  useEffect(() => {
    const emptyRow = {
      name: "",
      role: "",
      ec: "",
      1: "", // Ensure value exists, otherwise default to 0
      2: "",
      3: "",
      4: "",
      5: "",
      6: "",
      7: "",
      8: "",
      9: "",
      10: "",
      11: "",
      12: ""
    };

    // admin falttend data
    if (userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager"))) {
      const forAdminVisibilityDgmFlattenData = flattenedDataFunHandle(
        adminIncentives?.data?.dgmData
      );
      const forAdminVisibilityAgmFlattenData = flattenedDataFunHandle(
        adminIncentives?.data?.agmData
      );
      const forAdminVisibilitySmFlattenData = flattenedDataFunHandle(
        adminIncentives?.data?.smData
      );
      const forAdminVisibilityAsmFlattenData = flattenedDataFunHandle(
        adminIncentives?.data?.asmData
      );
      const forAdminVisibilitySeFlattenData = flattenedDataFunHandle(
        adminIncentives?.data?.executiveData
      );

      if (radioValue === "all") {
        setAdminCsvData([
          ...forAdminVisibilityDgmFlattenData,
          emptyRow,
          ...forAdminVisibilityAgmFlattenData,
          emptyRow,
          ...forAdminVisibilitySmFlattenData,
          emptyRow,
          ...forAdminVisibilityAsmFlattenData,
          emptyRow,
          ...forAdminVisibilitySeFlattenData,
        ]);
      setLeadData(
      flattenedLeadDataFunHandle([
        ...adminIncentives?.data?.dgmData,
        ...adminIncentives?.data?.agmData,
        ...adminIncentives?.data?.smData,
        ...adminIncentives?.data?.asmData,
        ...adminIncentives?.data?.executiveData,
      ])
    );
      } else if (radioValue === "DGM") {
        setAdminCsvData(forAdminVisibilityDgmFlattenData);
        setLeadData(flattenedLeadDataFunHandle(adminIncentives?.data?.dgmData));
      } else if (radioValue === "AGM") {
        setAdminCsvData(forAdminVisibilityAgmFlattenData);
         setLeadData(flattenedLeadDataFunHandle(adminIncentives?.data?.agmData));
      } else if (radioValue === "SM") {
        setAdminCsvData(forAdminVisibilitySmFlattenData);
        setLeadData(flattenedLeadDataFunHandle(adminIncentives?.data?.smData));
      } else if (radioValue === "ASM") {
        setAdminCsvData(forAdminVisibilityAsmFlattenData);
        setLeadData(flattenedLeadDataFunHandle(adminIncentives?.data?.asmData));
      } else if (radioValue === "SE") {
        setAdminCsvData(forAdminVisibilitySeFlattenData);
        setLeadData(flattenedLeadDataFunHandle(adminIncentives?.data?.executiveData));
      }
    }
    // Hierarchy falttend data
    else {
      const hierarchyDgmFlattenData = flattenedDataFunHandle(
        incentivesData?.data?.dgmData
      );
      const hierarchyAgmFlattenData = flattenedDataFunHandle(
        incentivesData?.data?.agmData
      );
      const hierarchySmFlattenData = flattenedDataFunHandle(
        incentivesData?.data?.smData
      );
      const hierarchyAsmFlattenData = flattenedDataFunHandle(
        incentivesData?.data?.asmData
      );
      const hierarchySeFlattenData = flattenedDataFunHandle(
        incentivesData?.data?.executiveData
      );

      if (radioValue === "NA") {
        setHierarchyCsvData([
          ...hierarchyDgmFlattenData,
          emptyRow,
          ...hierarchyAgmFlattenData,
          emptyRow,
          ...hierarchySmFlattenData,
          emptyRow,
          ...hierarchyAsmFlattenData,
          emptyRow,
          ...hierarchySeFlattenData,
        ]);
      } else if (radioValue === "DGM") {
        setHierarchyCsvData(hierarchyDgmFlattenData);
      } else if (radioValue === "AGM") {
        setHierarchyCsvData(hierarchyAgmFlattenData);
      } else if (radioValue === "SM") {
        setHierarchyCsvData(hierarchySmFlattenData);
      } else if (radioValue === "ASM") {
        setHierarchyCsvData(hierarchyAsmFlattenData);
      } else if (radioValue === "SE") {
        setHierarchyCsvData(hierarchySeFlattenData);
      }
    }
  }, [incentivesData, radioValue, adminIncentives]);

  useEffect(() => {
    if (!incentivesData?.data?.executiveData?.[0]?.data) {
      // console.error("Executive data is undefined or empty.");
      return;
    }
    // Extract unique `year` values
    const tempArr = incentivesData.data.executiveData[0].data.map((ele) =>
      ele
        ? { year: ele?.year, month: ele?.month }
        : "Unknown Year"
    );
    // Construct headers
    const headers = [
      { key: "name", label: "Name" },
      { key: "role", label: "Designation" },
      { key: "ec", label: "Experience-Center" },
      ...tempArr.map((ele) => ({
        key: ele?.month?.toString(),
        label: `${findMonthName(ele?.month)}-${ele?.year}`,
      })),
    ];
    setHierarchyHeader(headers);
  }, [incentivesData]);

  useEffect(() => {
    if (!adminIncentives?.data?.executiveData?.[0]?.data) {
      // console.error("Executive data is undefined or empty.");
      return;
    }
    // Extract unique `year` values
    const tempArr = adminIncentives?.data?.executiveData[0]?.data.map((ele) =>
      ele
        ? { year: ele?.year, month: ele?.month }
        : "Unknown Year"
    );
    // Construct headers
    const headers = [
      { key: "name", label: "Name" },
      { key: "role", label: "Designation" },
      { key: "ec", label: "Experience-Center" },
      ...tempArr.map((ele) => ({
        key: ele?.month?.toString(),
        label: `${findMonthName(ele?.month)}-${ele?.year}`,
      })),
    ];
    setHierarchyHeader(headers);
  }, [adminIncentives]);

    // Select Radio Button Logic
    useEffect(()=>{
      if(userDetails?.roles?.some((role) => role?.name === ROLENAME.DGM_Sales)){
        setRadioValue("DGM")
      }
      if(userDetails?.roles?.some((role) => role?.name === ROLENAME.AGMSales)){
        setRadioValue("AGM")
      }
      if(userDetails?.roles?.some((role) => role?.name === ROLENAME.AssistantSalesManager)){
        setRadioValue("ASM")
      }
      if(userDetails?.roles?.some((role) => role?.name === ROLENAME.SalesManager)){
        setRadioValue("SM")
      }
      if(userDetails?.roles?.some((role) => role?.name === ROLENAME.SalesUser)){
        setRadioValue("SE")
      }
    },[userDetails])

  const currentYear = new Date().getFullYear();
  const financialYears = [
    { value: currentYear - 2, label: `${currentYear - 2}` },
    { value: currentYear - 1, label: `${currentYear - 1}` },
    { value: currentYear, label: `${currentYear}` },
  ];
 //  loader beautiful
 if (loading) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "60vh",
        fontSize: "1.5rem",
        fontWeight: "500",
        color: "#1976d2",
        fontFamily: "sans-serif",
        letterSpacing: "0.5px"
      }}
    >
      <div
        style={{
          fontSize: "3rem",
          animation: "flip 1.2s infinite linear",
          display: "inline-block"
        }}
      >
        ⏳
      </div>
      <div style={{ marginTop: "10px" }}>Loading...</div>
  
      {/* Hourglass flip animation */}
      <style>
        {`
          @keyframes flip {
            0% { transform: rotate(0deg); }
            25% { transform: rotateX(180deg); }
            50% { transform: rotate(180deg); }
            75% { transform: rotateX(360deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}
//  role history modal open handle function
const handleOpenRoleHistory = (user) => {
  setSelectedUserName(user?.name);
  setSelectedRoleHistory(user?.roleHistory || []);
  setRoleHistoryModal(true);
};
// New headers for Leads excel
const leadsHeader = [
  { label: "Sl. No", key: "slNo" },
  { label: "Lead No", key: "leadNo" },
  { label: "Sales DGM", key: "salesDGM" },
  { label: "Sales AGM", key: "salesAGM" },
  { label: "Sales Manager", key: "salesManager" },
  { label: "Sales ASM", key: "salesASM" },
  { label: "Sales User", key: "salesUser" },
  { label: "Kickoff Date", key: "kickoffDate" },
  { label: "Amount", key: "amount" },
];
// Flattened Lead Data Function for second sheet in excel
function flattenedLeadDataFunHandle(data) {
  let rows = [];
  let seenLeadNos = new Set();

  data?.forEach((user) => {
    user?.data?.forEach((entry) => {
      entry?.leads?.forEach((lead) => {
        const leadNo = lead?.lead_no || "-";

        // Skip if we've already added this lead_no
        if (seenLeadNos.has(leadNo)) return;

        seenLeadNos.add(leadNo);

        rows.push({
          slNo: rows.length + 1,
          leadNo,
          salesDGM: lead?.salesDGM?.name || "-",
          salesAGM: lead?.salesAGM?.name || "-",
          salesManager: lead?.salesManager?.name || "-",
          salesASM: lead?.salesAssistantManager?.name || "-",
          salesUser: lead?.salesUser?.name || "-",
          // kickoffDate: lead?.kickoffDate
          //   ? moment(lead?.kickoffDate).format("DD-MM-YYYY")
          //   : "-",
          amount: lead?.amount || 0,
        });
      });
    });
  });

  return rows;
}

// multiple sheet excel download function
const exportToExcel = (sheetsData, fileName) => {
  // sheetsData = { Sheet1: { data, headers }, Sheet2: { data, headers } }

  const workbook = XLSX.utils.book_new();

  Object.keys(sheetsData).forEach((sheetName) => {
    const { data, headers } = sheetsData[sheetName];

    // Build rows: first row = headers, then data rows
    const worksheetData = [headers.map(h => h.label)];
    data.forEach(row => {
      worksheetData.push(headers.map(h => row[h.key]));
    });

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  });

  // Trigger download (xlsx provides writeFile directly)
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};


  return (
    <div>
      <Box style={{ display: "flex", justifyContent: "space-between" }}>
        {/* ----Year filter---- */}
        <Box sx={{ display: "flex" }}>
          <FormControl sx={{ m: 1, minWidth: 100 }} size="small">
            <InputLabel id="demo-select-small-label">Year</InputLabel>
            <Select
              labelId="demo-select-small-label"
              id="demo-select-small"
              value={yearFilterValue}
              label="Select Experience"
              onChange={(e) => {
                setYearFilterValue(e.target.value);
              }}
            >
              {financialYears.map((year) => (
                <MenuItem key={year.value} value={year.value}>
                  {year.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* -------------------Select Months----------------- */}

          <FormControl sx={{ m: 1, minWidth: 100 }} size="small">
            <InputLabel id="demo-select-small-label">Month</InputLabel>
            <Select
              labelId="demo-select-small-label"
              id="demo-select-small"
              value={monthFilter}
              label="Select Experience"
              onChange={(e) => {
                setMonthFilter(e.target.value);
              }}
            >
              <MenuItem value={"all"}>{"All"}</MenuItem>
              <MenuItem value={1}>{"Jan"}</MenuItem>
              <MenuItem value={2}>{"Feb"}</MenuItem>
              <MenuItem value={3}>{"March"}</MenuItem>
              <MenuItem value={4}>{"April"}</MenuItem>
              <MenuItem value={5}>{"May"}</MenuItem>
              <MenuItem value={6}>{"June"}</MenuItem>
              <MenuItem value={7}>{"July"}</MenuItem>
              <MenuItem value={8}>{"Aug"}</MenuItem>
              <MenuItem value={9}>{"Sept"}</MenuItem>
              <MenuItem value={10}>{"Oct"}</MenuItem>
              <MenuItem value={11}>{"Nov"}</MenuItem>
              <MenuItem value={12}>{"Dec"}</MenuItem>
            </Select>
          </FormControl>

          {/* ------------experience Center option------- */}
          {(userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager"))) && (
            <FormControl sx={{ m: 1, minWidth: 100 }} size="small">
              <InputLabel id="experience-center-label">
                Experience Center
              </InputLabel>
              <Select
                labelId="experience-center-label"
                id="experience-center-select"
                value={selectExperienceCenter}
                label="Experience Center"
                onChange={(e) => setSelectExperienceCenter(e.target.value)}
              >
                {/* Default Option */}
                <MenuItem value="all">All</MenuItem>

                {/* Render Options Dynamically */}
                {(userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager"))) &&
                  allExeperienceCenter?.data?.length > 0 &&
                  allExeperienceCenter.data.map((ele) => (
                    <MenuItem key={ele?._id} value={ele?._id}>
                      {ele.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          )}

          {/* choosing Active / Inactive  User Type*/} 
          {(userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager"))) &&
              (
                <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                <InputLabel id="user-type-label">User Type</InputLabel>
                <Select
                  labelId="user-type-label"
                  id="user-type"
                  value={userType} 
                  label="User Type"
                  onChange={(e) => setUserType(e.target.value)}
                >
                  <MenuItem value="false">Active</MenuItem>
                  <MenuItem value="true">Inactive</MenuItem>
                </Select>
              </FormControl>
              )}

          {/* ----Radio Button---- */}
          {!userDetails?.roles?.some((role) =>
            role?.name?.includes("Sales User") || role?.name?.includes("Admin") || role?.name === ROLENAME.CenterHead
            || role?.name === ROLENAME.FinanceManager || role?.name === ROLENAME.FinanceExecutive || role?.name === ROLENAME.FinanceUser
          ) && (
              <Box>
                <FormControl
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "5px",
                  }}
                >
                  <FormLabel
                    id="demo-radio-buttons-group-label"
                    sx={{ marginLeft: "10px", marginRight: "10px" }}
                  >
                    Select Role
                  </FormLabel>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={radioValue}
                    name="radio-buttons-group"
                    sx={{ display: "flex", flexDirection: "row" }} // Add flexDirection: "row"
                    onChange={(e) => {
                      setRadioValue(e.target.value);
                    }}
                  >
                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("Sales Head") ||
                        role?.name?.includes("Center Head") ||
                        role?.name?.includes("DGM Sales") ||
                        role?.name?.includes("AGM Sales") ||
                        role?.name?.includes("Finance Executive") ||
                        role?.name?.includes("Finance User") ||
                        role?.name?.includes("Finance Manager")
                    ) && (
                      <FormControlLabel
                        value="all"
                        control={<Radio />}
                        label="All"
                      />
                      )} 
                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("DGM Sales") ||
                        role?.name?.includes("Sales Head") ||
                        role?.name?.includes("Center Head") ||
                        role?.name?.includes("Finance Executive") ||
                        role?.name?.includes("Finance User") ||
                        role?.name?.includes("Finance Manager")
                    ) && (
                        <FormControlLabel
                          value="DGM"
                          control={<Radio />}
                          label="DGM"
                        />
                      )}
                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("DGM Sales") ||
                        role?.name?.includes("Sales Head") ||
                        role?.name?.includes("AGM Sales") ||
                        role?.name?.includes("Center Head") ||
                        role?.name?.includes("Finance Executive") ||
                        role?.name?.includes("Finance User") ||
                        role?.name?.includes("Finance Manager")
                    ) && (
                        <FormControlLabel
                          value="AGM"
                          control={<Radio />}
                          label="AGM"
                        />
                      )}
                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("DGM Sales") ||
                        role?.name?.includes("Sales Head") ||
                        role?.name?.includes("AGM Sales") ||
                        !role?.name?.includes("Assistant Sales Manager") ||
                        role?.name?.includes("Center Head") ||
                        role?.name?.includes("Finance Executive") ||
                        role?.name?.includes("Finance User") ||
                        role?.name?.includes("Finance Manager")
                    ) && (
                        <FormControlLabel
                          value="SM"
                          control={<Radio />}
                          label="SM"
                        />
                      )}
                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("DGM Sales") ||
                        role?.name?.includes("Sales Head") ||
                        role?.name?.includes("AGM Sales") ||
                        role?.name?.includes("Assistant Sales Manager") ||
                        role?.name?.includes("Sales Manager") ||
                        role?.name?.includes("Center Head") ||
                        role?.name?.includes("Finance Executive") ||
                        role?.name?.includes("Finance User") ||
                        role?.name?.includes("Finance Manager")
                    ) && (
                        <FormControlLabel
                          value="ASM"
                          control={<Radio />}
                          label="ASM"
                        />
                      )}
                    <FormControlLabel value="SE" control={<Radio />} label="SE" />
                  </RadioGroup>
                </FormControl>
              </Box>
            )}

          {/* ---- NEW Radio Button---- */}
          {userDetails?.roles?.some((role) =>
            role?.name?.includes("Admin") || role?.name === ROLENAME.CenterHead
            || role?.name === ROLENAME.FinanceManager || role?.name === ROLENAME.FinanceExecutive || role?.name === ROLENAME.FinanceUser
          ) && (
              <Box>
                <FormControl
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "5px",
                  }}
                >
                  <FormLabel
                    id="demo-radio-buttons-group-label"
                    sx={{ marginLeft: "10px", marginRight: "10px" }}
                  >
                    Select Role
                  </FormLabel>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={radioValue}
                    name="radio-buttons-group"
                    sx={{ display: "flex", flexDirection: "row" }} // Add flexDirection: "row"
                    onChange={(e) => {
                      setRadioValue(e.target.value);

                    }}
                  >
                    <FormControlLabel
                      value="all"
                      control={<Radio />}
                      label="All"
                    />
                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("DGM Sales") ||
                        role?.name?.includes("Sales Head") ||
                        role?.name?.includes("Center Head") ||
                        role?.name?.includes("Finance Executive") ||
                        role?.name?.includes("Finance User") ||
                        role?.name?.includes("Finance Manager")
                    ) && (
                        <FormControlLabel
                          value="DGM"
                          control={<Radio />}
                          label="DGM"
                        />
                      )}
                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("DGM Sales") ||
                        role?.name?.includes("Sales Head") ||
                        role?.name?.includes("AGM Sales") ||
                        role?.name?.includes("Center Head") ||
                        role?.name?.includes("Finance Executive") ||
                        role?.name?.includes("Finance User") ||
                        role?.name?.includes("Finance Manager")
                    ) && (
                        <FormControlLabel
                          value="AGM"
                          control={<Radio />}
                          label="AGM"
                        />
                      )}
                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("DGM Sales") ||
                        role?.name?.includes("Sales Head") ||
                        role?.name?.includes("AGM Sales") ||
                        !role?.name?.includes("Assistant Sales Manager") ||
                        role?.name?.includes("Center Head") ||
                        role?.name?.includes("Finance Executive") ||
                        role?.name?.includes("Finance User") ||
                        role?.name?.includes("Finance Manager")
                    ) && (
                        <FormControlLabel
                          value="SM"
                          control={<Radio />}
                          label="SM"
                        />
                      )}
                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("DGM Sales") ||
                        role?.name?.includes("Sales Head") ||
                        role?.name?.includes("AGM Sales") ||
                        role?.name?.includes("Assistant Sales Manager") ||
                        role?.name?.includes("Sales Manager") ||
                        role?.name?.includes("Center Head") ||
                        role?.name?.includes("Finance Executive") ||
                        role?.name?.includes("Finance User") ||
                        role?.name?.includes("Finance Manager")
                    ) && (
                        <FormControlLabel
                          value="ASM"
                          control={<Radio />}
                          label="ASM"
                        />
                      )}
                    <FormControlLabel value="SE" control={<Radio />} label="SE" />
                  </RadioGroup>
                </FormControl>
              </Box>
            )}
        </Box>
        {/* ----Download Csv---- */}
        {(!userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager")) &&
          hierarchyCsvData?.length > 0 && (monthFilter === "all" || monthFilter == monthFilter) && hierarchyHeader.length > 0) && (
            <Button
              variant="contained"
              color="primary"
              style={{
                height: "40px",
                marginTop: "6px",
                marginLeft: "8px",
                fontSize: "12px",
              }}
              className={classes.downloadButton}
            >
              <CSVLink
                data={hierarchyCsvData}
                headers={hierarchyHeader}
                filename={`incentives of ${yearFilterValue}`}
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  // fontSize: "15px",
                }}
              >
                Download CSV Data
              </CSVLink>
            </Button>
          )}

        {(userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager")) &&
          adminCsvData?.length > 0 && (monthFilter === "all" || monthFilter == monthFilter) && hierarchyHeader.length > 0) && (
            <Button
              variant="contained"
              color="primary"
              style={{
                height: "40px",
                marginTop: "6px",
                marginLeft: "8px",
                fontSize: "12px",
              }}
              className={classes.downloadButton}
               onClick={() =>
              exportToExcel(
                {
                  Incentive: { data: adminCsvData, headers: hierarchyHeader },
                  Leads: { data: leadData, headers: leadsHeader },
                },
                `incentives of ${yearFilterValue}`
              )
            }
            >
              Download CSV Data
            </Button>   
          )}
      </Box>
      <Box style={{ textAlign: "right" }}>
        {" "}
        <b> All the amounts are showing in lacs ( ₹ )</b>
        {monthFilter !== "all" &&
          !(userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager"))) &&
          Array.isArray(incentivesData?.data?.executiveData) &&
          incentivesData?.data?.executiveData[0]?.data?.length > 0 && (
            <h4 style={{ marginTop: "10px", color: "green" }}>
              Showing data in table for {" "}
              {findMonthName(
                incentivesData?.data?.executiveData[0]?.data[0]?.month
              )}{" "}
              {incentivesData?.data?.executiveData[0]?.data[0]?.year} To 11th{" "} 
              {findMonthName(
                incentivesData?.data?.executiveData[1]?.data[1]?.month
              )}{" "}
              {incentivesData?.data?.executiveData[1]?.data[1]?.year}
            </h4>
          )}
        {monthFilter !== "all" &&
          (userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager"))) &&
          Array.isArray(adminIncentives?.data?.executiveData) &&
          adminIncentives?.data?.executiveData[0]?.data?.length > 0 && (
            <h4 style={{ marginTop: "10px", color: "green" }}>
              Showing data in table from 11th{" "}
              {findMonthName(
                adminIncentives?.data?.executiveData[0]?.data[0]?.month
              )}{" "}
              {adminIncentives?.data?.executiveData[0]?.data[0]?.year} To 11th{" "}
              {findMonthName(
                adminIncentives?.data?.executiveData[1]?.data[1]?.month
              )}{" "}
              {adminIncentives?.data?.executiveData[1]?.data[1]?.year}
            </h4>
          )}
      </Box>
      {userDetails?.roles?.some(
        (role) =>
          role?.name?.includes("Admin") ||
          role?.name?.includes("Center Head") ||
          role?.name?.includes("Finance Executive") ||
          role?.name?.includes("Finance User") ||
          role?.name?.includes("Finance Manager")
      ) &&
        radioValue !== "NA" && // Ensures the message doesn't show when radioValue is "NA"
        !adminIncentives?.data?.dgmData?.length &&
        !adminIncentives?.data?.agmData?.length &&
        !adminIncentives?.data?.smData?.length &&
        !adminIncentives?.data?.asmData?.length &&
        !adminIncentives?.data?.executiveData?.length && (
          <div style={{ textAlign: "center" }}>
            No Data found for {yearFilterValue}
          </div>
        )}
      {!(userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager"))) &&
        !incentivesData?.data?.dgmData?.length > 0 &&
        !incentivesData?.data?.agmData?.length > 0 &&
        !incentivesData?.data?.smData?.length > 0 &&
        !incentivesData?.data?.asmData?.length > 0 &&
        !incentivesData?.data?.executiveData?.length > 0 && (
          <div style={{ textAlign: "center" }}>
            No Data found for {yearFilterValue}
          </div>
        )}

      {/* -------------------Admin Table DGM---------------- */}
      {(userDetails?.roles?.some((role) => (role?.name?.includes("Admin")) || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager"))) &&
        JSON.stringify(adminIncentives) !== "{}" &&
        (radioValue === "all" || radioValue === "DGM") &&
        adminIncentives?.data?.dgmData[0]?.data?.length > 0 && (
          <div>
            <h3> DGM Table </h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                       Exp Center
                    </TableCell>
                    {JSON.stringify(adminIncentives) !== "{}" &&
                      adminIncentives?.data?.dgmData[0]?.data?.map((ele) => {
                        return (
                          <TableCell
                            className={classes.tableCell}
                            key={`${ele.month}-${ele.year}`}
                            style={{
                              fontWeight: 800,
                              backgroundColor: "#cccccc",
                            }}
                          >
                            {findMonthName(ele.month)}-{ele.year}
                          </TableCell>
                        );
                      })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {adminIncentives?.data?.dgmData?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className={classes.tableCell} >
                          {index + 1}
                        </TableCell>
                        <TableCell className={classes.tableCell}  onClick={() => handleOpenRoleHistory(item)} style={{ cursor: "pointer" }}>
                          {item.name}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          <Tooltip
                            title={item?.experienceCenters?.join(", ") || ""}
                            arrow
                            placement="top"
                          >
                            <span>
                              {item?.experienceCenters?.slice(0, 2).map((ec, index, array) => {
                                const truncatedEc = ec.length > 19 ? `${ec.slice(0, 19)}..` : ec;
                                return (
                                  <span key={index}>
                                    {truncatedEc}
                                    {index < array.length - 1 ? ", " : ""}
                                  </span>
                                );
                              })}
                              {item?.experienceCenters?.length > 2 ? ".." : ""}
                            </span>
                          </Tooltip>
                        </TableCell>
                        {item.data.map((ele) => {
                          return (
                            <TableCell className={classes.tableCell}>
                              {formatRupees(ele?.incentive)}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                  {/* <TableCell className={classes.tableCell}>{index + 1}</TableCell> */}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      {/* -------------------Admin Table AGM---------------- */}
      {(userDetails?.roles?.some((role) => (role?.name?.includes("Admin")) || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager"))) &&
        JSON.stringify(adminIncentives) !== "{}" &&
        (radioValue === "all" || radioValue === "AGM") &&
        adminIncentives?.data?.agmData[0]?.data?.length > 0 && (
          <div>
            <h3 style={{marginTop:"12px"}}> AGM Table </h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                       Exp Center
                    </TableCell>
                    {JSON.stringify(adminIncentives) !== "{}" &&
                      adminIncentives?.data?.agmData[0]?.data?.map((ele) => {
                        return (
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              fontWeight: 800,
                              backgroundColor: "#cccccc",
                            }}
                          >
                            {findMonthName(ele.month)}-{ele.year}
                          </TableCell>
                        );
                      })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {adminIncentives?.data?.agmData?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className={classes.tableCell}>
                          {index + 1}
                        </TableCell>
                        <TableCell className={classes.tableCell} onClick={() => handleOpenRoleHistory(item)} style={{ cursor: "pointer" }}>
                          {item.name}
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          <Tooltip
                            title={item?.experienceCenters?.join(", ") || ""}
                            arrow
                            placement="top"
                          >
                            <span>
                              {item?.experienceCenters?.slice(0, 2).map((ec, index, array) => {
                                const truncatedEc = ec.length > 19 ? `${ec.slice(0, 19)}..` : ec;
                                return (
                                  <span key={index}>
                                    {truncatedEc}
                                    {index < array.length - 1 ? ", " : ""}
                                  </span>
                                );
                              })}
                              {item?.experienceCenters?.length > 2 ? ".." : ""}
                            </span>
                          </Tooltip>
                        </TableCell>
                        {item.data.map((ele) => {
                          return (
                            <TableCell className={classes.tableCell}>
                              {formatRupees(ele?.incentive)}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                  {/* <TableCell className={classes.tableCell}>{index + 1}</TableCell> */}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      {/* -------------------Admin Table SM---------------- */}
      {(userDetails?.roles?.some((role) => (role?.name?.includes("Admin")) || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager"))) &&
        JSON.stringify(adminIncentives) !== "{}" &&
        (radioValue === "all" || radioValue === "SM") &&
        adminIncentives?.data?.smData[0]?.data?.length > 0 && (
          <div>
            <h3 style={{marginTop:"12px"}}> SM Table </h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                       Exp Center
                    </TableCell>
                    {JSON.stringify(adminIncentives) !== "{}" &&
                      adminIncentives?.data?.smData[0]?.data?.map((ele) => {
                        return (
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              fontWeight: 800,
                              backgroundColor: "#cccccc",
                            }}
                          >
                            {findMonthName(ele.month)}-{ele.year}
                          </TableCell>
                        );
                      })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {adminIncentives?.data?.smData?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className={classes.tableCell}>
                          {index + 1}
                        </TableCell>
                        <TableCell className={classes.tableCell} onClick={() => handleOpenRoleHistory(item)} style={{ cursor: "pointer" }}>
                          {item.name}
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          <Tooltip
                            title={item?.experienceCenters?.join(", ") || ""}
                            arrow
                            placement="top"
                          >
                            <span>
                              {item?.experienceCenters?.slice(0, 2).map((ec, index, array) => {
                                const truncatedEc = ec.length > 19 ? `${ec.slice(0, 19)}..` : ec;
                                return (
                                  <span key={index}>
                                    {truncatedEc}
                                    {index < array.length - 1 ? ", " : ""}
                                  </span>
                                );
                              })}
                              {item?.experienceCenters?.length > 2 ? ".." : ""}
                            </span>
                          </Tooltip>
                        </TableCell>
                        {item.data.map((ele) => {
                          return (
                            <TableCell className={classes.tableCell}>
                              {formatRupees(ele?.incentive)}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                  {/* <TableCell className={classes.tableCell}>{index + 1}</TableCell> */}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      {/* -------------------Admin Table ASM---------------- */}
      {(userDetails?.roles?.some((role) => (role?.name?.includes("Admin")) || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager"))) &&
        (radioValue === "all" || radioValue === "ASM") &&
        JSON.stringify(adminIncentives) !== "{}" &&
        adminIncentives?.data?.asmData[0]?.data?.length > 0 && (
          <div>
            <h3 style={{marginTop:"12px"}}> ASM Table </h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                       Exp Center
                    </TableCell>
                    {JSON.stringify(adminIncentives) !== "{}" &&
                      adminIncentives?.data?.asmData[0]?.data?.map((ele) => {
                        return (
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              fontWeight: 800,
                              backgroundColor: "#cccccc",
                            }}
                          >
                            {findMonthName(ele.month)}-{ele.year}
                          </TableCell>
                        );
                      })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {adminIncentives?.data?.asmData?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className={classes.tableCell}>
                          {index + 1}
                        </TableCell>
                        <TableCell className={classes.tableCell} onClick={() => handleOpenRoleHistory(item)} style={{ cursor: "pointer" }}>
                          {item.name}
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          <Tooltip
                            title={item?.experienceCenters?.join(", ") || ""}
                            arrow
                            placement="top"
                          >
                            <span>
                              {item?.experienceCenters?.slice(0, 2).map((ec, index, array) => {
                                const truncatedEc = ec.length > 19 ? `${ec.slice(0, 19)}..` : ec;
                                return (
                                  <span key={index}>
                                    {truncatedEc}
                                    {index < array.length - 1 ? ", " : ""}
                                  </span>
                                );
                              })}
                              {item?.experienceCenters?.length > 2 ? ".." : ""}
                            </span>
                          </Tooltip>
                        </TableCell>
                        {item.data.map((ele) => {
                          return (
                            <TableCell className={classes.tableCell}>
                              {formatRupees(ele?.incentive)}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                  {/* <TableCell className={classes.tableCell}>{index + 1}</TableCell> */}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      {/* -------------------Admin Table SE---------------- */}
      {(userDetails?.roles?.some((role) => (role?.name?.includes("Admin")) || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager"))) &&
        (radioValue === "all" || radioValue === "SE") &&
        JSON.stringify(adminIncentives) !== "{}" &&
        adminIncentives?.data?.executiveData[0]?.data?.length > 0 && (
          <div>
            <h3 style={{marginTop:"12px"}}> SE Table </h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                       Exp Center
                    </TableCell>
                    {JSON.stringify(adminIncentives) !== "{}" &&
                      adminIncentives?.data?.executiveData[0]?.data?.map(
                        (ele) => {
                          return (
                            <TableCell
                              className={classes.tableCell}
                              style={{
                                fontWeight: 800,
                                backgroundColor: "#cccccc",
                              }}
                            >
                              {findMonthName(ele.month)}-{ele.year}
                            </TableCell>
                          );
                        }
                      )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {adminIncentives?.data?.executiveData?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className={classes.tableCell}>
                          {index + 1}
                        </TableCell>
                        <TableCell className={classes.tableCell} onClick={() => handleOpenRoleHistory(item)} style={{ cursor: "pointer" }}>
                          {item.name}
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          <Tooltip
                            title={item?.experienceCenters?.join(", ") || ""}
                            arrow
                            placement="top"
                          >
                            <span>
                              {item?.experienceCenters?.slice(0, 2).map((ec, index, array) => {
                                const truncatedEc = ec.length > 19 ? `${ec.slice(0, 19)}..` : ec;
                                return (
                                  <span key={index}>
                                    {truncatedEc}
                                    {index < array.length - 1 ? ", " : ""}
                                  </span>
                                );
                              })}
                              {item?.experienceCenters?.length > 2 ? ".." : ""}
                            </span>
                          </Tooltip>
                        </TableCell>
                        {item?.data?.map((ele) => {
                          return (
                            <TableCell className={classes.tableCell}>
                              {formatRupees(ele?.incentive)}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                  {/* <TableCell className={classes.tableCell}>{index + 1}</TableCell> */}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      {/* -------------------Hierarchy Table DGM---------------- */}
      {!(userDetails?.roles?.some((role) => (role?.name?.includes("Admin")) || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager"))) &&
        JSON.stringify(incentivesData) !== "{}" &&
        (radioValue === "all" || radioValue === "NA" || radioValue === "DGM") &&
        Array.isArray(incentivesData?.data?.dgmData) && // Check if dgmData is an array
        incentivesData?.data?.dgmData[0]?.data?.length > 0 && (
          <div>
            <h3> DGM Table </h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                       Exp Center
                    </TableCell>
                    {JSON.stringify(incentivesData) !== "{}" &&
                      incentivesData?.data?.dgmData[0]?.data?.map((ele) => {
                        return (
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              fontWeight: 800,
                              backgroundColor: "#cccccc",
                            }}
                          >
                            {findMonthName(ele.month)}-{ele.year}
                          </TableCell>
                        );
                      })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {incentivesData?.data?.dgmData?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className={classes.tableCell}>
                          {index + 1}
                        </TableCell>
                        <TableCell className={classes.tableCell} onClick={() => handleOpenRoleHistory(item)} style={{ cursor: "pointer" }}>
                          {item.name}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          <Tooltip
                            title={item?.experienceCenters?.join(", ") || ""}
                            arrow
                            placement="top"
                          >
                            <span>
                              {item?.experienceCenters?.slice(0, 2).map((ec, index, array) => {
                                const truncatedEc = ec.length > 19 ? `${ec.slice(0, 19)}..` : ec;
                                return (
                                  <span key={index}>
                                    {truncatedEc}
                                    {index < array.length - 1 ? ", " : ""}
                                  </span>
                                );
                              })}
                              {item?.experienceCenters?.length > 2 ? ".." : ""}
                            </span>
                          </Tooltip>
                        </TableCell>
                        {item.data.map((ele) => {
                          return (
                            <TableCell className={classes.tableCell}>
                              {formatRupees(ele?.incentive)}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                  {/* <TableCell className={classes.tableCell}>{index + 1}</TableCell> */}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      {/* -------------------Hierarchy Table AGM---------------- */}
      {!(userDetails?.roles?.some((role) => (role?.name?.includes("Admin")) || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager"))) &&
        JSON.stringify(incentivesData) !== "{}" &&
        (radioValue === "all" || radioValue === "NA" || radioValue === "AGM") &&
        Array.isArray(incentivesData?.data?.dgmData) && // Check if dgmData is an array
        incentivesData?.data?.agmData[0]?.data?.length > 0 && (
          <div>
            <h3 style={{marginTop:"12px"}}> AGM Table </h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                       Exp Center
                    </TableCell>
                    {JSON.stringify(incentivesData) !== "{}" &&
                      incentivesData?.data?.agmData[0]?.data?.map((ele) => {
                        return (
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              fontWeight: 800,
                              backgroundColor: "#cccccc",
                            }}
                          >
                            {findMonthName(ele.month)}-{ele.year}
                          </TableCell>
                        );
                      })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {incentivesData?.data?.agmData?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className={classes.tableCell}>
                          {index + 1}
                        </TableCell>
                        <TableCell className={classes.tableCell} onClick={() => handleOpenRoleHistory(item)} style={{ cursor: "pointer" }}>
                          {item.name}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          <Tooltip
                            title={item?.experienceCenters?.join(", ") || ""}
                            arrow
                            placement="top"
                          >
                            <span>
                              {item?.experienceCenters?.slice(0, 2).map((ec, index, array) => {
                                const truncatedEc = ec.length > 19 ? `${ec.slice(0, 19)}..` : ec;
                                return (
                                  <span key={index}>
                                    {truncatedEc}
                                    {index < array.length - 1 ? ", " : ""}
                                  </span>
                                );
                              })}
                              {item?.experienceCenters?.length > 2 ? ".." : ""}
                            </span>
                          </Tooltip>
                        </TableCell>
                        {item.data.map((ele) => {
                          return (
                            <TableCell className={classes.tableCell}>
                              {formatRupees(ele?.incentive)}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                  {/* <TableCell className={classes.tableCell}>{index + 1}</TableCell> */}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      {/* -------------------Hierarchy Table SM---------------- */}
      {!(userDetails?.roles?.some((role) => (role?.name?.includes("Admin")) || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager"))) &&
        JSON.stringify(incentivesData) !== "{}" &&
        (radioValue === "all" || radioValue === "NA" || radioValue === "SM") &&
        Array.isArray(incentivesData?.data?.dgmData) && // Check if dgmData is an array
        incentivesData?.data?.smData[0]?.data?.length > 0 && (
          <div>
            <h3 style={{marginTop:"12px"}}> SM Table </h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                       Exp Center
                    </TableCell>
                    {JSON.stringify(incentivesData) !== "{}" &&
                      incentivesData?.data?.smData[0]?.data?.map((ele) => {
                        return (
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              fontWeight: 800,
                              backgroundColor: "#cccccc",
                            }}
                          >
                            {findMonthName(ele.month)}-{ele.year}
                          </TableCell>
                        );
                      })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {incentivesData?.data?.smData?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className={classes.tableCell}>
                          {index + 1}
                        </TableCell>
                        <TableCell className={classes.tableCell} onClick={() => handleOpenRoleHistory(item)} style={{ cursor: "pointer" }}>
                          {item.name}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {item?.experienceCenters?.map((ec, index, array) => {
                            return (
                              <span key={index}>
                                {ec}
                                {index < array.length - 1 ? ", " : ""}
                              </span>
                            );
                          })}
                        </TableCell>
                        {item.data.map((ele) => {
                          return (
                            <TableCell className={classes.tableCell}>
                              {formatRupees(ele?.incentive)}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                  {/* <TableCell className={classes.tableCell}>{index + 1}</TableCell> */}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      {/* -------------------Hierarchy Table ASM---------------- */}
      {!(userDetails?.roles?.some((role) => (role?.name?.includes("Admin")) || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager"))) &&
        JSON.stringify(incentivesData) !== "{}" &&
        (radioValue === "all" || radioValue === "NA" || radioValue === "ASM") &&
        Array.isArray(incentivesData?.data?.dgmData) && // Check if dgmData is an array
        incentivesData?.data?.asmData[0]?.data?.length > 0 && (
          <div>
            <h3 style={{marginTop:"12px"}}> ASM Table </h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                       Exp Center
                    </TableCell>
                    {JSON.stringify(incentivesData) !== "{}" &&
                      incentivesData?.data?.asmData[0]?.data?.map((ele) => {
                        return (
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              fontWeight: 800,
                              backgroundColor: "#cccccc",
                            }}
                          >
                            {findMonthName(ele.month)}-{ele.year}
                          </TableCell>
                        );
                      })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {incentivesData?.data?.asmData?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className={classes.tableCell}>
                          {index + 1}
                        </TableCell>
                        <TableCell className={classes.tableCell} onClick={() => handleOpenRoleHistory(item)} style={{ cursor: "pointer" }}>
                          {item.name}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {item?.experienceCenters?.map((ec, index, array) => {
                            return (
                              <span key={index}>
                                {ec}
                                {index < array.length - 1 ? ", " : ""}
                              </span>
                            );
                          })}
                        </TableCell>
                        {item.data.map((ele) => {
                          return (
                            <TableCell className={classes.tableCell}>
                              {formatRupees(ele?.incentive)}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                  {/* <TableCell className={classes.tableCell}>{index + 1}</TableCell> */}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      {/* -------------------Hierarchy Table SE---------------- */}
      {!(userDetails?.roles?.some((role) => (role?.name?.includes("Admin")) || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager"))) &&
        JSON.stringify(incentivesData) !== "{}" &&
        (radioValue === "all" || radioValue === "NA" || radioValue === "SE") &&
        Array.isArray(incentivesData?.data?.dgmData) && // Check if dgmData is an array
        incentivesData?.data?.executiveData[0]?.data?.length > 0 && (
          <div>
            <h3 style={{marginTop:"12px"}}> SE Table </h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                       Exp Center
                    </TableCell>
                    {JSON.stringify(incentivesData) !== "{}" &&
                      incentivesData?.data?.executiveData[0]?.data?.map(
                        (ele) => {
                          return (
                            <TableCell
                              className={classes.tableCell}
                              style={{
                                fontWeight: 800,
                                backgroundColor: "#cccccc",
                              }}
                            >
                              {findMonthName(ele.month)}-{ele.year}
                            </TableCell>
                          );
                        }
                      )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {incentivesData?.data?.executiveData?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className={classes.tableCell}>
                          {index + 1}
                        </TableCell>
                        <TableCell className={classes.tableCell} onClick={() => handleOpenRoleHistory(item)} style={{ cursor: "pointer" }}>
                          {item.name}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {item?.experienceCenters?.map((ec, index, array) => {
                            return (
                              <span key={index}>
                                {ec}
                                {index < array.length - 1 ? ", " : ""}
                              </span>
                            );
                          })}
                        </TableCell>
                        {item.data.map((ele) => {
                          return (
                            <TableCell className={classes.tableCell}>
                              {formatRupees(ele?.incentive)}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                  {/* <TableCell className={classes.tableCell}>{index + 1}</TableCell> */}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
        <>
        <Modal
          open={roleHistoryModal}
          onClose={() => setRoleHistoryModal(false)}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 600,
              bgcolor: "background.paper",
              boxShadow: 24,
              borderRadius: 2,
              p: 3,
            }}
          >
            <h2>Role History of {selectedUserName}</h2>
            {selectedRoleHistory.length > 0 ? (
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ fontWeight: 800, backgroundColor: "#cccccc" }}>Role</TableCell>
                      <TableCell style={{ fontWeight: 800, backgroundColor: "#cccccc" }}>Effective Date</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedRoleHistory.map((role, idx) => (
                      <TableRow key={idx}>
                        <TableCell>{role.roleName}</TableCell>
                        <TableCell>{new Date(role.startDate).toLocaleDateString()}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <p>No role history available.</p>
            )}
          </Box>
        </Modal>

        </>
    </div>
  );
}

export default connect(null, { setLoading, setSnackInfo })(Incentives);
